import Rx from 'rxjs';
import { push } from 'react-router-redux';
import { combineEpics } from 'redux-observable';

import * as constAction from 'root/actionConstants';
import * as mensajesActions from 'modules/mensajes/action';
import * as generalActions from 'modules/general/action';
import * as errorActions from 'modules/error/action';
import { request } from 'core/generalFunctions';

const { ajax } = Rx.Observable;

export const getEpic = (action$, store) =>
  action$.ofType(constAction.MENSAJES_GET).switchMap(action =>
    ajax(request(action))
      .map(({ response }) => mensajesActions.setState({ lista: response }))
      .catch(err => errorActions.request(err, action))
      .startWith(generalActions.loadingbar_show())
      .finally(() => store.dispatch(generalActions.loadingbar_hide())),
  );

export const setEpic = (action$, store) =>
  action$
    .ofType(constAction.MENSAJES_SET)
    .throttleTime(2000)
    .switchMap(action =>
      ajax(request(action))
        .mergeMap(() => [push('/dashboard/mensajes'), generalActions.snackbar_show('Mensaje enviado')])
        .catch(err => errorActions.request(err, action))
        .startWith(generalActions.loadingbar_show())
        .finally(() => store.dispatch(generalActions.loadingbar_hide())),
    );

export const setUsuarioEpic = (action$, store) =>
  action$
    .ofType(constAction.MENSAJES_USUARIO_SET)
    .throttleTime(2000)
    .switchMap(action =>
      ajax(request(action))
        .mergeMap(() => [push('/dashboard/mensajes'), generalActions.snackbar_show('Mensaje enviado')])
        .catch(err => errorActions.request(err, action))
        .startWith(generalActions.loadingbar_show())
        .finally(() => store.dispatch(generalActions.loadingbar_hide())),
    );

export const getUsuarioEpic = (action$, store) =>
  action$.ofType(constAction.MENSAJES_USUARIO_GET).switchMap(action =>
    ajax(request(action))
      .map(({ response }) => mensajesActions.setState({ listaUsuario: response }))
      .catch(err => errorActions.request(err, action))
      .startWith(generalActions.loadingbar_show())
      .finally(() => store.dispatch(generalActions.loadingbar_hide())),
  );

export const deleteEpic = (action$, store) =>
  action$
    .ofType(constAction.MENSAJES_DELETE)
    .throttleTime(2001)
    .switchMap(action =>
      ajax(request(action))
        .mergeMap(() => [mensajesActions.get(), generalActions.snackbar_show('Mensaje borrado')])
        .catch(err => errorActions.request(err, action))
        .startWith(generalActions.loadingbar_show())
        .finally(() => store.dispatch(generalActions.loadingbar_hide())),
    );

export default combineEpics(getEpic, setEpic, deleteEpic, setUsuarioEpic, getUsuarioEpic);



// WEBPACK FOOTER //
// src/modules/mensajes/epics.js